<p-multiSelect 
    [options]="privilegeGroup"
    [(ngModel)]="privilegeGroupSelected"
    [defaultLabel]="processing ? 'Loading..' : defaultLabel"
    [filterPlaceHolder]="filterPlaceHolder"
    [disabled]="disabled || processing"
    [maxSelectedLabels]="maxSelectedLabels"
    (onChange)="change($event.value)"
    (onBlur)="blur()"
    optionLabel="GroupName"
    >
  </p-multiSelect>